import _ from 'lodash';

function UnderlyingPolicy(data) {
    if (data) {
        _.extend(this, data);
        this.isExternal = !_.isNil(data.isExternal) ? data.isExternal : true;
    } else {
        this.isExternal = true;
    }
}

UnderlyingPolicy.prototype.getDisplayNameShort = function (InsuranceSuiteMetadata, translator) {
    let name = '';
    if (this.carrier) {
        const carrierTypelist = InsuranceSuiteMetadata.get('pc').types.getTypelist('ULCarrier_PUE');
        if (this.carrier === 'Other') {
            name += `${this.otherCarrier} `;
        } else {
            const carrierCode = carrierTypelist.getCode(this.carrier).name;
            const carrierName = translator({id: carrierCode, defaultMessage: carrierCode});
            name += `${carrierName} `;
        }
    }
    if (this.policyType) {
        const policyTypeTypelist = InsuranceSuiteMetadata.get('pc').types.getTypelist('PUPULPolicyType_PUE');
        const policyTypeCode = policyTypeTypelist.getCode(this.policyType).name;
        const policyTypeName = translator({id: policyTypeCode, defaultMessage: policyTypeCode});
        name += `${policyTypeName} `;
    }
    return name;
};

UnderlyingPolicy.prototype.getDisplayName = function (InsuranceSuiteMetadata, translator) {
    let name = this.getDisplayNameShort(InsuranceSuiteMetadata, translator);
    name += this.policyNumber;
    return name;
};

export default UnderlyingPolicy;
